var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 0.366969C15.9999 0.128901 16.2818 0.00319554 16.4589 0.162268L42.772 23.7941C42.8937 23.9034 42.8937 24.0942 42.772 24.2035L16.4589 47.8353C16.2818 47.9943 15.9999 47.8686 15.9999 47.6306L15.9999 33.6505C15.9999 33.5707 16.0346 33.4948 16.0949 33.4425L26.7597 24.2065C26.8864 24.0968 26.8864 23.9003 26.7597 23.7906L16.0949 14.5545C16.0346 14.5023 15.9999 14.4264 15.9999 14.3466L15.9999 0.366969Z",
    fill: "#004B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7113 24.2333C16.8599 24.1132 16.8599 23.8868 16.7113 23.7667L9.98859 18.3327C9.7924 18.1742 9.5 18.3138 9.5 18.5661L9.5 29.4339C9.5 29.6862 9.7924 29.8258 9.98858 29.6673L16.7113 24.2333Z",
    fill: "#004B8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow_next.22435849b6811ffd6d447083c7585007.svg";
export { ForwardRef as ReactComponent };